import React, { Fragment } from "react"
import _map from "lodash/map"

import classnames from "classnames"
import styles from "./styles.css"

const NegotiationSkeleton = () => {
  const titleClasses = classnames(styles.skeletonText, styles.skeleton)
  const subtitleClasses = classnames(styles.skeletonSmallText, styles.skeleton)

  const invoicesInfoCardClasses = classnames(
    styles.commons,
    styles.invoicesInfoCardSkeleton,
    styles.whiteBackgroundSkeleton
  )
  const invoicesInfoCardItemClasses = classnames(
    styles.invoicesInfoCardItem,
    styles.skeleton
  )

  const headerSelectClasses = classnames(
    styles.commons,
    styles.headerSelectSkeleton,
    styles.whiteBackgroundSkeleton
  )
  const containerSelectClasses = classnames(
    styles.containerSelect,
    styles.skeleton
  )

  const invoicesSectionClasses = classnames(
    styles.commons,
    styles.invoicesSectionSkeleton,
    styles.whiteBackgroundSkeleton
  )

  const invoicesInfoItemClasses = classnames(
    styles.invoicesInfoItem,
    styles.skeleton
  )

  const headerClasses = classnames(styles.header, styles.skeleton)

  const itemTableClasses = classnames(styles.skeleton)

  const itemsClasses = classnames(styles.itemsClasses)

  const itemValueClasses = classnames(styles.skeleton, styles.itemValue)

  const buttonClasses = classnames(styles.button, styles.skeleton)

  return (
    <Fragment>
      <div className={titleClasses}></div>

      <div className={invoicesInfoCardClasses}>
        <div className={subtitleClasses}></div>
        <div className={invoicesInfoCardItemClasses}></div>
      </div>

      <div className={headerSelectClasses}>
        <div className={subtitleClasses}></div>
        <div className={containerSelectClasses}></div>
      </div>

      <div className={invoicesSectionClasses}>
        <div className={subtitleClasses}></div>
        <div className={invoicesInfoItemClasses}></div>
        <div className={headerClasses}></div>

        <table className={styles.table}>
          <thead className={styles.tableHeader}>
            <tr>
              {_map(Array(5), (_, index) => (
                <th key={index} className={itemTableClasses}></th>
              ))}
            </tr>
          </thead>
          <tbody className={styles.tableBody}>
            {_map(Array(3), (_, rowIndex) => (
              <tr key={rowIndex} className={itemsClasses}>
                {_map(Array(5), (_, colIndex) => (
                  <th key={colIndex} className={itemValueClasses}></th>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        <div className="u-flex u-flexJustifyBetween">
          {_map(Array(2), (_, index) => (
            <div key={index} className={buttonClasses}></div>
          ))}
        </div>
      </div>
    </Fragment>
  )
}

export default NegotiationSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/NegotiationSkeleton/index.js